import { render, staticRenderFns } from "./scene6.vue?vue&type=template&id=5bc43ae0&scoped=true&"
import script from "./scene6.vue?vue&type=script&lang=ts&"
export * from "./scene6.vue?vue&type=script&lang=ts&"
import style0 from "./scene6.vue?vue&type=style&index=0&id=5bc43ae0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc43ae0",
  null
  
)

export default component.exports